<template>
  <div class="scroll-shortcut" v-if="!isPageShort">
    <div class="scroll-btn up" :style="{ opacity: isAtTop ? '0.3' : '1', cursor: isAtTop ? 'default' : 'pointer' }" @click="!isAtTop && scrollToTop()">
      <i class="fa fa-arrow-up"></i>
    </div>
    <div class="scroll-divider"></div>
    <div class="scroll-btn down" :style="{ opacity: isAtBottom ? '0.3' : '1', cursor: isAtBottom ? 'default' : 'pointer' }" @click="!isAtBottom && scrollToBottom()">
      <i class="fa fa-arrow-down"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScrollShortcut',
  data() {
    return {
      isPageShort: false,
      isAtTop: true,
      isAtBottom: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // Initial check
    
    // Watch for dynamic height changes (e.g. infinite scroll loading data)
    this.resizeObserver = new ResizeObserver(() => {
      this.handleScroll();
    });
    this.resizeObserver.observe(document.body);

    // Watch for DOM insertions (reliable for Vue infinite scroll appending items)
    this.mutationObserver = new MutationObserver(() => {
      setTimeout(() => this.handleScroll(), 50);
    });
    this.mutationObserver.observe(document.body, { childList: true, subtree: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  },
  methods: {
    handleScroll() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight
      );
      
      this.isPageShort = documentHeight <= windowHeight;
      this.isAtTop = scrollY < 50;
      this.isAtBottom = (scrollY + windowHeight) >= (documentHeight - 50);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    scrollToBottom() {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  }
}
</script>

<style scoped>
/* Scroll Shortcut FAB */
.scroll-shortcut {
  position: fixed;
  bottom: 40px;
  right: 20px;
  background-color: rgba(30, 30, 30, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}
.scroll-btn {
  padding: 12px 14px;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}
.scroll-btn:hover {
  color: rgba(255, 255, 255, 0.9);
  background-color: rgba(255, 255, 255, 0.05);
}
.scroll-divider {
  width: 50%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
}

@media (max-width: 767.98px) {
  .scroll-shortcut {
    display: none !important;
  }
}
</style>
